module.exports = __webpack_public_path__ + "img/20190624161323038.6077a5b8.png";